import { useEffect, useState } from 'react'

/** Tailwind `md` — tables stay; below this we stack to cards. */
export const NARROW_VIEWPORT_QUERY = '(max-width: 767px)'

function readNarrow(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false
  }
  return window.matchMedia(NARROW_VIEWPORT_QUERY).matches
}

/**
 * True below 768px (iPhone 14 Pro is 393). jsdom has no matchMedia by
 * default, so tests keep the desktop table path unless they stub it.
 */
export function useNarrowViewport(): boolean {
  const [narrow, setNarrow] = useState(readNarrow)

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return
    const media = window.matchMedia(NARROW_VIEWPORT_QUERY)
    const onChange = () => setNarrow(media.matches)
    onChange()
    media.addEventListener('change', onChange)
    return () => media.removeEventListener('change', onChange)
  }, [])

  return narrow
}
